import React, { useState } from "react";
import { $host } from "../../../../../http";
import "../UserModal.css"; // Используем общие стили

const EditUserModal = ({ user, onClose }) => {
    const [email, setEmail] = useState(user.email || "");
    const [firstName, setFirstName] = useState(user.first_name || "");
    const [lastName, setLastName] = useState(user.last_name || "");
    const [receiveEmail, setReceiveEmail] = useState(user.receive_email || false);
    const [loading, setLoading] = useState(false);

    const handleUpdateUser = async () => {
        setLoading(true);
        try {
            await $host.put(`/api/admin/users/${user.id}`, {
                email: email.toLowerCase(),
                first_name: firstName.toLowerCase(),
                last_name: lastName.toLowerCase(),
                receive_email: receiveEmail,
            });

            alert("Данные пользователя успешно обновлены!");
            onClose();
        } catch (error) {
            console.error("Ошибка обновления данных пользователя:", error);
            alert("Не удалось обновить данные пользователя.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close" onClick={onClose}>✖</button>
                <h3 className="modal-header">Редактирование пользователя</h3>

                <div className="modal-section">
                    <label className="modal-label">Email:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="modal-input"
                    />
                </div>

                <div className="modal-section">
                    <label className="modal-label">Имя:</label>
                    <input
                        type="text"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        className="modal-input"
                    />
                </div>

                <div className="modal-section">
                    <label className="modal-label">Фамилия:</label>
                    <input
                        type="text"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        className="modal-input"
                    />
                </div>

                <div className="modal-section checkbox-group">
                    <label className="modal-label">
                        <input
                            type="checkbox"
                            checked={receiveEmail}
                            onChange={() => setReceiveEmail(!receiveEmail)}
                        />
                        Подтвердить email
                    </label>
                </div>

                <div className="modal-footer">
                    <button className="modal-button modal-primary" onClick={handleUpdateUser} disabled={loading}>
                        {loading ? "Сохранение..." : "Сохранить"}
                    </button>
                    <button className="modal-button modal-danger" onClick={onClose}>Отмена</button>
                </div>
            </div>
        </div>
    );
};

export default EditUserModal;
